import { getExceptionHandler } from "@alfa-web-tools/requests-utils";
import { UseNavigateReturnType } from '@alfa-retail-react/components/navigate-hook';

import { NetworkException } from 'app/api/exception/NetworkException';
import {
    ERROR_PAGE_URL,
    ErrorPageState,
} from 'app/logic/pages/error/ErrorPage';

interface INetworkExceptionHandlerOnSubmitData {
    setPageErrors: (error: string[]) => void;
}
export const networkExceptionHandlerOnSubmitData = ({
    setPageErrors,
}: INetworkExceptionHandlerOnSubmitData) => {
    return getExceptionHandler(
        NetworkException.NAME,
        (exception: NetworkException) => {
            setPageErrors([exception.message]);
        },
    );
};

interface INetworkExceptionHandlerOnLoadData {
    navigate: UseNavigateReturnType;
}

export const networkExceptionHandlerOnLoadData = ({
    navigate,
}: INetworkExceptionHandlerOnLoadData) => {
    return getExceptionHandler(
        NetworkException.NAME,
        (exception: NetworkException) => {
            navigate<ErrorPageState>(ERROR_PAGE_URL, {
                messages: [exception.message],
            });
        },
    );
};
